/** Same 6-minute lock CvPassportPrefs / Profile use during CV re-embedding. */
export function checkUploadInProgress(): number {
  const ts = localStorage.getItem('cv_upload_timestamp');
  if (!ts) return 0;
  try {
    const elapsed = Date.now() - parseInt(ts, 10);
    const remaining = 6 * 60 * 1000 - elapsed;
    if (remaining > 0) return Math.ceil(remaining / 60000);
    localStorage.removeItem('cv_upload_timestamp');
  } catch {
    localStorage.removeItem('cv_upload_timestamp');
  }
  return 0;
}
